import React, { useContext } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import DACoreLogo from '@wix/da-ds/pkg/DACoreLogo';
import cn from 'classnames';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import Heading from '@wix/da-a11y/pkg/components/headings/Heading';
import { Props } from '../HeroHeader';
import PlanExpiringNote from '../HeroHeader/PlanExpiringNote';
import GiftRecipient from '../HeroHeader/GiftRecipient';
import s from './SaleHeroHeader.scss';

const SaleHeroHeader: React.FC<Props> = ({
  hasCore,
  giftUser,
  currentCoreSubscription,
  sale,
  showSubtitle = true,
}) => {
  const { t } = useTranslation();
  const isMobile = useContext(MobileContext);
  const planWillExpire = currentCoreSubscription?.willExpire;
  let title;
  let subtitle;

  if (giftUser) {
    title = t('packagePicker.heroTable.header.gift');
  } else if (hasCore) {
    title = (
      <Trans
        i18nKey={`packagePicker.heroTable.header.upgradeWithLogo${
          isMobile ? '.mobile' : ''
        }`}
      >
        Upgrade Your <DACoreLogo className={s['core-logo']} /> Plan
      </Trans>
    );

    subtitle = t('packagePicker.heroTable.saleHeader.subtitle.limitedOffer', {
      discount: sale?.discountValuePercent,
    });
  } else {
    title = (
      <Trans
        i18nKey={`packagePicker.heroTable.header.noCoreWithLogo${
          isMobile ? '.mobile' : ''
        }`}
      >
        Upgrade to a <DACoreLogo className={s['core-logo']} /> Plan
      </Trans>
    );

    subtitle = t('packagePicker.heroTable.saleHeader.subtitle.limitedOffer', {
      discount: sale?.discountValuePercent,
    });
  }

  return (
    <div
      className={cn(
        s['root'],
        giftUser && s['is-gift'],
        !giftUser && !hasCore && s['no-core'],
        !giftUser && hasCore && s['has-core']
      )}
    >
      <Heading className={s['title']}>{title}</Heading>
      {!giftUser && planWillExpire && (
        <PlanExpiringNote endTimestamp={currentCoreSubscription.endts!} />
      )}
      {subtitle && showSubtitle && (
        <Heading className={s['subtitle']}>{subtitle}</Heading>
      )}
      {giftUser && <GiftRecipient user={giftUser} />}
    </div>
  );
};
SaleHeroHeader.displayName = 'SaleHeroHeader';

export default SaleHeroHeader;
